import {ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import { MaterialService } from '../material/material.service';
import { PanelStylesService } from '../panel-styles/panel-styles.service';
import {HeightService} from '../height/height.service';
import {WorksurfaceService} from '../worksurface/worksurface.service';
import {DoorService} from '../door/door.service';
import {TitleCasePipe} from '@angular/common';

@Component({
  selector: 'app-visuals',
  imports: [
    TitleCasePipe
  ],
  templateUrl: './visuals.html',
  styleUrl: './visuals.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Visuals {
  private panelStylesService = inject(PanelStylesService);
  protected materialService = inject(MaterialService);
  private heightService = inject(HeightService);
  private worksurfaceService = inject(WorksurfaceService);
  private doorService = inject(DoorService);

  protected selectedHeight = computed(() =>this.heightService.selectedHeight());
  protected selectedWorksurface = computed(() => this.worksurfaceService.selectedWorksurface());

  protected selectedPanelStyle = computed(() => this.panelStylesService.selectedStyle());

  protected t0Mat = this.materialService.getSelection('T0');
  protected t1Mat = this.materialService.getSelection('T1');
  protected t2Mat = this.materialService.getSelection('T2');
  protected t3Mat = this.materialService.getSelection('T3');

  protected worksurface = this.worksurfaceService.selectedWorksurface;
  protected door = this.doorService.selectedDoor;

  readonly zones = computed(() => {
    const height = this.heightService.selectedHeight();
    const style = this.panelStylesService.selectedStyle();

    let result = ['T2', 'T1'];

    return result;
  });

  protected selections = computed(() =>
    this.zones().map(zone => ({
      zone,
      ...this.materialService.getSelection(zone)()
    }))
  );

  protected t0Dir = computed(() => {
    return false;
  });

  protected t1Dir = computed(() => {
    return 'T1';
  });

  protected t2Dir = computed(() => {
    const style = this.selectedPanelStyle();
    console.log('Panel Style: ' + style);
    if (!style) return false;

    if (style?.startsWith('39')){
      return 'T2/G3';
    }

    if(style?.startsWith('52')){
      if (style?.endsWith('S')){
        return 'T2/G1'
      } else {
        return 'T2/G5';
      }
    }

    if(style?.startsWith('65')){
      if(style?.endsWith('S')){
        return 'T2/G2';
      } else if (style?.endsWith('DG')){
        return 'T2/G4';
      } else {
        return 'T2/G1';
      }
    }

    return false;
  });

  protected t3Dir = computed(() => {
    return false;
  });
}
